import actionTypes from '../../actions/actionTypes';

const initialState = {
    updateTaskDocument: {
        updateNeeded: false,
        documentType: '',
    },
    changePageTaskDocument: {
        updateNeeded: false,
    },
    cancelTaskDocument: {
        updateNeeded: false,
    },
};

const TaskReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_TASK_DOCUMENT:
            return {
                ...state,
                updateTaskDocument: {
                    updateNeeded: action.payload.updateNeeded,
                    documentType: action.payload.documentType,
                },
            };
        case actionTypes.UPDATE_TASK_DOCUMENT_CLEAR:
            return {
                ...state,
                updateTaskDocument: {
                    updateNeeded: false,
                    documentType: '',
                },
            };
        case actionTypes.CANCEL_TASK_DOCUMENT:
            return {
                ...state,
                cancelTaskDocument: {
                    updateNeeded: action.payload.updateNeeded,
                },
            };
        case actionTypes.CANCEL_TASK_DOCUMENT_CLEAR:
            return {
                ...state,
                cancelTaskDocument: {
                    updateNeeded: false,
                },
            };
        case actionTypes.CHANGE_PAGE_TASK_DOCUMENT:
            return {
                ...state,
                changePageTaskDocument: {
                    updateNeeded: action.payload.updateNeeded,
                },
            };

        case actionTypes.CHANGE_PAGE_TASK_DOCUMENT_CLEAR:
            return {
                ...state,
                changePageTaskDocument: {
                    updateNeeded: false,
                },
            };
        default:
            return state;
    }
};

export default TaskReducer;
